export default "__VITE_ASSET__22a76975__"